import { z } from 'zod';

export const companyResponsibleSchema = z.object({
  responsibleName: z.string().min(1),
  responsibleEmail: z.string().email(),
  responsiblePhone: z.string().min(1),
});

export type ICompanyResponsibleFormSchema = z.infer<
  typeof companyResponsibleSchema
>;
